import { useMemo, useState } from "react";
import { createColumnHelper } from "@tanstack/react-table";
import type { Imputacion } from "../Imputaciones";
import { TypedTable } from "@/components/TypedTable";
import { ModalAceptarImputacion } from "./ModalImputacion";
import style from "../Imputaciones.module.scss";

interface TablaImputacionesProps { readonly imputaciones: Imputacion[]; }
export function TablaImputaciones(props: TablaImputacionesProps) {
	const [modal, setModal] = useState<Imputacion | null>(null);

	const columns = useMemo(() => {
		const columnHelper = createColumnHelper<Imputacion>();

		const getAccionesImputacion = (imputacion: Imputacion) => {
			return (
				<div className={style.accionesImputaciones}>
					<button onClick={() => setModal(imputacion)} type="button">
						<i className="fa fa-info" />
					</button>
				</div>
			);
		};

		return [
			columnHelper.accessor("lote", { header: "Lote", meta: { className: "dt-center" } }),
			columnHelper.accessor("nombreArticulo", { id: "articulo", header: "Artículo", meta: { className: "dt-center" } }),
			columnHelper.accessor("nombreRepresentante", { header: "Representante", meta: { className: "dt-center" } }),
			columnHelper.accessor("fecha", {
				header: "Fecha", cell: info => {
					const value = info.getValue();
					return !value ? "" : new Date(value * 1000).toLocaleDateString("es-ES");
				}, meta: { className: "dt-center" }
			}),

			columnHelper.display({
				id: "actions",
				header: "",
				meta: { className: "p-0 h-full" },
				cell: ({ row }) => getAccionesImputacion(row.original),
			}),

		];
	}, []);

	const onClickDT = (event: React.MouseEvent<HTMLDivElement>) => {
		const target = (event.target as HTMLElement | null)?.closest(".mostrarModalLanzarInputacion") as HTMLElement | null;
		if (!target) {
			return;
		}
		const idImputacion = target.dataset.idImputacion;
		if (idImputacion) {
			parseInt(idImputacion);
		}
	};
	return (
		<div onClick={onClickDT}>
			<TypedTable
				className="dataTable display"
				data={props.imputaciones}
				columns={columns}

				pagination
				globalSearch
			/>

			<ModalAceptarImputacion show={modal != null} close={() => setModal(null)} imputacion={modal} />
		</div>
	);
}